import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { Profile } from "~/pages/Profile";

export const Route = createFileRoute("/_app/profile")({
  head: () => ({ meta: [{ title: i18n.t("general:header.profile") }] }),
  component: Profile,
});
